import { render, staticRenderFns } from "./qianshuHeader.vue?vue&type=template&id=2b21fd63&scoped=true"
import script from "./qianshuHeader.vue?vue&type=script&lang=js"
export * from "./qianshuHeader.vue?vue&type=script&lang=js"
import style0 from "./qianshuHeader.vue?vue&type=style&index=0&id=2b21fd63&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b21fd63",
  null
  
)

export default component.exports